import { render } from "./CollaboratorsView.vue?vue&type=template&id=54a5ee81&scoped=true"
import script from "./CollaboratorsView.vue?vue&type=script&lang=js"
export * from "./CollaboratorsView.vue?vue&type=script&lang=js"

import "./CollaboratorsView.vue?vue&type=style&index=0&id=54a5ee81&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-54a5ee81"

export default script